<mat-tab-group mat-align-tabs="start">
  <mat-tab label="Dashboard">
    <app-dashboard></app-dashboard>
  </mat-tab>
</mat-tab-group>


